import React from 'react';
export var LoadingStrategy;
(function (LoadingStrategy) {
    LoadingStrategy["Hydrate"] = "hydrate";
    LoadingStrategy["Interaction"] = "interaction";
})(LoadingStrategy || (LoadingStrategy = {}));
const useDynamicImports = (scripts, strategy) => {
    const [packageRefs, setPackageRefs] = React.useState({});
    const importsDepsUpdate = JSON.stringify(Object.keys(scripts));
    const hasLoaded = Object.keys(scripts).every(key => packageRefs[key]);
    const loadImports = React.useCallback(async () => {
        const clonedRefs = { ...packageRefs };
        await Promise.all(Object.entries(scripts).map(async ([key, val]) => {
            if (!clonedRefs[key]) {
                const res = await val();
                clonedRefs[key] = res?.default || res;
            }
        }));
        setPackageRefs(clonedRefs);
        // eslint-disable-next-line
    }, [importsDepsUpdate]);
    React.useEffect(() => {
        if (strategy === LoadingStrategy.Hydrate) {
            loadImports();
        }
    }, [loadImports, strategy]);
    return {
        hasLoaded,
        scripts: packageRefs,
        load: loadImports,
    };
};
export default useDynamicImports;
//# sourceMappingURL=use-dynamic-imports.js.map